import { Controller } from "@hotwired/stimulus"
import axios from 'axios'

export default class extends Controller {

  static get targets() {
  }

  connect(){
  }

  initialize() {
  }

  resetProgression(event) {
    event.preventDefault();

    const parent = event.srcElement.parentElement;
    const surveyId = parent.querySelector('input[name="surveyId"]').value;
    const participantId = parent.querySelector('input[name="participantId"]').value;
    const surveyHashId = parent.querySelector('input[name="surveyHashId"]').value;
    const locale = parent.querySelector('input[name="locale"]').value;

    return axios({
      method: 'post',
      url: Env.api_url + "/app-ruby/reset-progression",
      data: {
        surveyId,
        participantId,
      },
      headers: {'accept': 'application/javascript'}
    })
    .then((response) => {
      if (response.data?.resumeStepId) {
        window.location.href = '/' + locale + '/surveys/' + surveyHashId + '?step_id=' + response.data.resumeStepId;
        return;
      }
      window.location.pathname.includes('/surveys') && !window.location.pathname.includes('/confirmation') ? window.location.reload() : window.location.href = '/' + locale + '/surveys/' + surveyHashId;
    })
  }
}
